import script from "./OverspeedTrackPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./OverspeedTrackPopup.vue?vue&type=script&setup=true&lang=js"

import "./OverspeedTrackPopup.vue?vue&type=style&index=0&id=408b8646&lang=scss"

const __exports__ = script;

export default __exports__